import { useEffect, useRef } from 'react';

/*
 * it's the same as useEffect only it will not run effect on initial render
 * */
export function useDidMountEffect(effect, deps) {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    effect();
  }, deps);
}
